/** Hardcoded project type flags (backend: lowercase enums). */
export const PROJECT_TYPE_OPTIONS = [
    { value: "fca", label: "FCA" },
    { value: "adc", label: "ADC" }
];

const ALLOWED = new Set(["fca", "adc"]);
const LABEL_MAP = { fca: "FCA", adc: "ADC" };

/**
 * Normalize API/local values to a sorted unique list of "fca" | "adc".
 */
export const normalizeProjectTypesFromApi = raw => {
    let arr = raw;
    if (typeof raw === "string") {
        try {
            const parsed = JSON.parse(raw);
            arr = Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }
    if (!Array.isArray(arr)) return [];
    const out = [];
    for (const x of arr) {
        const v = String(x).toLowerCase();
        if (ALLOWED.has(v) && !out.includes(v)) out.push(v);
    }
    return out.sort((a, b) => a.localeCompare(b));
};

/** Display string for table/info (e.g. "FCA", "ADC", "FCA, ADC"). */
export const formatProjectTypesLabel = types => {
    const n = normalizeProjectTypesFromApi(types);
    const labels = n.map(t => LABEL_MAP[t]).filter(Boolean);
    return labels.length ? labels.join(", ") : "-";
};

/** Asset Lifecycle filter is shown only when project is ADC-only (not FCA-only or mixed). */
export const isAdcOnlyProjectTypes = types => {
    const n = normalizeProjectTypesFromApi(types);
    return n.length === 1 && n[0] === "adc";
};
